export default __webpack_public_path__ + "static/media/betaTester.b9e3e150.png";